export const roleDialogFeatureEs = {
  Dashboard: "Permite al usuario acceder y ver el panel de control.",
  Analytics: "Permite al usuario acceder y configurar los paneles de análisis.",
  CatalogManagement: "Permite al usuario gestionar los elementos del catálogo.",
  Customers:
    "Permite al usuario ver y gestionar perfiles de clientes y crear cuentas de portal de clientes para que estos puedan cargar directamente órdenes de compra en el Portal Dost.",
  DeveloperSettings:
    "Permite al usuario acceder y modificar la configuración de desarrollador y de la API.",
  DiscrepancyConfigurations:
    "Permite al usuario establecer y actualizar las reglas de discrepancia.",
  DocumentConfigurations:
    "Permite al usuario configurar campos, formatos y reglas de documentos.",
  Documents: "Permite al usuario ver y gestionar documentos.",
  ExportConfigurations:
    "Permite al usuario configurar y gestionar las reglas de exportación.",
  ExportTemplates:
    "Permite al usuario crear y mantener plantillas de exportación.",
  Integrations: "Permite al usuario configurar y gestionar integraciones.",
  ManualDocumentsDN:
    "Permite al usuario crear y gestionar notas de entrega manuales.",
  ManualDocumentsIN: "Permite al usuario crear y gestionar facturas manuales.",
  ManualDocumentsPO:
    "Permite al usuario crear y gestionar órdenes de compra manuales.",
  MappingConfigurations:
    "Permite al usuario configurar y actualizar las reglas de mapeo.",
  Payments: "Permite al usuario ver y gestionar registros de pago.",
  Report: "Permite al usuario acceder y añadir informes.",
  RoleManagement: "Permite al usuario crear y gestionar roles de usuario.",
  SelfTraining:
    "Permite al usuario entrenar la IA usando documentos personalizados.",
  Suppliers:
    "Permite al usuario ver y gestionar perfiles de proveedores y crear cuentas de portal de proveedores para que estos puedan cargar directamente facturas en el Portal Dost.",
  UserManagement:
    "Permite al usuario añadir y gestionar usuarios del Portal Dost.",
  WorkflowApproval: "Permite al usuario aprobar/rechazar los documentos.",
  WorkflowManagement:
    "Permite al usuario configurar los ajustes de aprobación para que los documentos se envíen a la persona correcta cuando se cumplan condiciones específicas.",
  NotificationApp:
    "Dar al usuario la posibilidad de aprobar o rechazar documentos directamente desde Slack, indicando los motivos.",
  Employee: `Permitir al usuario gestionar empleados`,
  Expenses: `Permitir al usuario gestionar gastos`,
  ExpenseCategory: `Permitir que el usuario agregue una categoría de gasto`,
  InvoicePayments: `Permitir al usuario gestionar los pagos de facturas`,
  PaymentSchedule: `Permitir al usuario gestionar los calendarios de pagos`,
  Items: `Permitir al usuario gestionar los artículos`,
  Taxes: `Permitir al usuario gestionar los impuestos`,
  DocumentCustomView: `Permite al usuario crear y gestionar vistas personalizadas de documentos con filtros y columnas personalizados.`,
};
